// extracted by mini-css-extract-plugin
export default {"dot":"styles_dot__HbZV8"};